// Mirrors BarcloudApi.PresentationModels.Enums.PersonImportErrorType
export enum PersonImportErrorType {
  departmentCodeNotFound = 1,
  managerCodeNotFound = 2,
  personEmailInvalid = 3,
  personEmailAlreadyExists = 4,
  personEmailDuplicateInFile = 5,
  personCodeAlreadyExists = 6,
  personCodeNotFound = 7,
  personCodeDuplicateInFile = 8,
  siteCodeNotFound = 9,
}

export interface ValidateImportResultItem {
  message?: string;
  error?: string;
  errorTypes?: PersonImportErrorType[];
}
